var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{ref:"element"},[_c('b-col',{attrs:{"md":"4"}},[_c('label',[_vm._v("Created Events")]),_c('v-select',{attrs:{"label":"start_time","options":_vm.eventsList},on:{"option:selected":_vm.setSelectedEventData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }